import React from 'react';
import Link from './Link';

export default function LinkButton({
  buttonStyle = 'primary',
  fluid = false,
  className = '',
  ...props,
}) {
  return (
    <Link
      className={`button-${buttonStyle} ${className} ${fluid ? 'button-fluid text-center' : ''}`}
      {...props}
    />
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/LinkButton.js